@if (readonly) {
  <div
    style="
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: start;
      gap: 10px;
    "
  >
    <div style="display: flex">
      <input
        type="checkbox"
        id="{{ myId }}"
        style="width: 25px; height: 25px"
        [disabled]="true"
        [(ngModel)]="boundValue"
      />
    </div>
    <div style="display: flex; text-align: left; min-width: 150px">
      <div class="label" style="vertical-align: middle">{{ label }}</div>
    </div>
  </div>
}

<div [style]="style">
  @if (!readonly) {
    <div style="width: 100%; margin-bottom: 10px" id="{{ myId }}_container">
      <div style="position: relative; display: inline-block">
        <input
          type="checkbox"
          id="{{ myId }}"
          style="position: relative; width: 25px; height: 25px"
          [hidden]="readonly"
          [(ngModel)]="boundValue"
          (change)="handle_change($event)"
        />
        <span
          class="tb-validation-msg"
          style="left: -30px; bottom: -12px"
          [hidden]="!required"
          >required</span
        >
        <div style="position: absolute; left: 0px; top: 0px">
          @if (helpText != '') {
            <div class="helpOverlay" (mouseover)="showHelp($event)">?</div>
          }
        </div>
        @if (helpVisible && helpText != '') {
          <div
            id="{{ myId }}_h"
            (mouseout)="hideHelp($event)"
            (click)="$event.stopPropagation()"
            class="contextHelpBox"
            style="left: 0px; top: 0px; min-width: 200px"
          >
            {{ helpText }}
          </div>
        }
      </div>
      <div
        style="
          display: inline-block;
          color: #777777;
          font-size: 0.95em;
          top: 50%;
          transform: translateY(-50%);
          padding-left: 5px;
        "
      >
        {{ label }}
      </div>
    </div>
  }
</div>
